import { Box, Typography } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';

type InfoAlertBoxProps = {
    text: string;
};

const InfoAlertBox = ({ text }: InfoAlertBoxProps) => (
    <Box
        data-testid="info-alert-box"
        role="alert"
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            padding: 1.5,
            borderRadius: 1,
            background: '#ECF2FE',
        }}
    >
        <ErrorOutline sx={{ color: '#437EF6', fontSize: 20 }} />
        <Typography variant="body2" sx={{ color: '#1B3262' }}>
            {text}
        </Typography>
    </Box>
);

export default InfoAlertBox;
